import { IFormSection, TSubmitType } from "../../types/common";
import {
  API_EXPENSES,
  API_PAYMENT_MODES_CONFIGURABLES,
} from "../../utils/apis";

import { URL_EXPENSES } from "../../utils/urls";
import { getAndPrepareFiles, getResultOptions } from "../../utils/helpers";
import {
  BOOLEAN_SELECTIONS,
  EXPENSE_TYPE,
  FORM_DATA,
} from "../../utils/constants";
import { useGetConfigurableOptions } from "../../utils/formUtils";
import { useEffect } from "react";
import useGet from "../common/useGet";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const useExpenseForm = ({ form }) => {
  const sections: IFormSection[] = [
    {
      title: "Expense Information",
      fields: [
        {
          field_name: "expense_type",
          type: "select",
          label: "Expense Type",
          props: { required: true },
          options_name: "expense_types",
        },
        {
          field_name: "amount",
          type: "number",
          label: "Expense Amount",
          props: { required: true },
        },
        {
          field_name: "expense_date",
          type: "date",
          label: "Expense Date",
          props: { required: true },
        },
        {
          field_name: "is_recurring",
          type: "select",
          label: "Is Recurring",
          props: { required: true },
          options_data: BOOLEAN_SELECTIONS,
        },
        {
          field_name: "recurring_frequency",
          type: "select",
          label: "Recurring Frequency",
          props: { required: true },
          options_data: [
            { id: "daily", name: "Daily" },
            { id: "weekly", name: "Weekly" },
            { id: "monthly", name: "Monthly" },
            { id: "quarterly", name: "Quarterly" },
            { id: "annually", name: "Annually" },
          ],
          visible: form?.is_recurring == true,
        },
        {
          field_name: "description",
          type: "textarea",
          label: "Description",
        },
        {
          field_name: "accounting_category",
          type: "select",
          label: "Accounting Category",
          props: { required: true },
          options_data: [
            { id: "cost_of_goods_sold", name: "Cost of Goods Sold" },
            { id: "operating_expenses", name: "Operating Expenses" },
            { id: "administrative_expenses", name: "Administrative Expenses" },
          ],
        },
        {
          field_name: "payment_method",
          type: "select",
          label: "Payment Method",
          props: { required: true },
          options_name: "payment_modes",
        },
      ],
    },
    {
      title: "Payee Information",
      fields: [
        {
          field_name: "payee_first_name",
          type: "text",
          label: "First Name",
          props: { required: true },
        },
        {
          field_name: "payee_last_name",
          type: "text",
          label: "Last Name",
          props: { required: true },
        },
        {
          field_name: "payee_other_name",
          type: "text",
          label: "Other Name",
        },
        {
          field_name: "payee_phone_number",
          type: "tel",
          label: "Payee Phone Number",
        },
        {
          field_name: "payee_email",
          type: "email",
          label: "Payee Email",
        },
        {
          field_name: "payee_address",
          type: "textarea",
          label: "Payee Address",
          props: { required: true },
        },
      ],
    },
    {
      title: "Supporting Documents",
      fields: [
        {
          field_name: "invoice",
          type: "file",
          label: "Invoice / Receipt",
        },
      ],
    },
  ];

  const redirect = `${URL_EXPENSES}`;

  const getConfigOptions = () => {
    const configList = [{ name: "expense_types", key: EXPENSE_TYPE }];
    const { loadData: getPaymentModes, data: paymentModes } = useGet();
    useEffect(() => {
      getPaymentModes({
        api: API_PAYMENT_MODES_CONFIGURABLES,
        params: { active: true },
      });
    }, []);
    return {
      ...useGetConfigurableOptions(configList),
      payment_modes: getResultOptions(paymentModes, "mode", "mode"),
    };
  };
  const options = {
    ...getConfigOptions(),
  };

  return { sections, redirect, options };
};

export function submitExpense(payload: any, id: number | null) {
  const files = ["invoice"];
  let preppedPayload = getAndPrepareFiles(payload, files);
  return {
    api: API_EXPENSES,
    id,
    type: FORM_DATA,
    params: preppedPayload,
  };
}
